import { code_length, idw_url, kjw_url, id4_url, spw_url} from "./config";
import { Api } from "../services/service";

export const global = {
  generateCodeKuponJajan,
  loadCSS,
  portalRedirect,
};

function generateCodeKuponJajan() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const length = code_length;
  const max = chars.length;
  

  // Secure random bytes
  const arr = new Uint32Array(length);
  window.crypto.getRandomValues(arr);

  let code = "";
  for (let i = 0; i < length; i++) {
    code += chars[arr[i] % max];
  }

  // Tambahkan 1 digit ekstra dari timestamp untuk uniqueness
  const salt = (Date.now() % 36).toString(36).toUpperCase();
  return code.slice(0, length - 1) + salt;
}

function loadCSS(href) {
  return new Promise((resolve) => {
    // kalau sudah pernah di-load, jangan load lagi
    if (document.querySelector(`link[href="${process.env.BASE_URL}${href}"]`)) {
      return resolve()
    }

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.onload = resolve
    document.head.appendChild(link)
  })
}

const PORTAL_URLS = {
  KJW: kjw_url,
  IDW: idw_url,
  ID4: id4_url,
};

const LOW_PRIORITY_PORTAL_URLS = {
  SPW: spw_url,
};
 
const COOKIE_NAME = 'shared_session_id';

function getCookieValue() {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(COOKIE_NAME + '='));
  return match ? decodeURIComponent(match.slice(COOKIE_NAME.length + 1)) : null;
}

async function resolveUrl(defaultUrl) {
  const sessionCookie = getCookieValue();

  if (!sessionCookie) {
    return defaultUrl;
  }

  try {
    const response = await Api.getSessionKeyword(sessionCookie);
    const data = response.data;
    if (!data || !data.success) {
      return defaultUrl;
    }

    const usedKeywords = new Set();

    if (Array.isArray(data.keywords)) {
      data.keywords.forEach(kw => usedKeywords.add(String(kw).toUpperCase().trim()));
    } else if (data.keyword) {
      usedKeywords.add(String(data.keyword).toUpperCase().trim());
    }

    if (usedKeywords.size === 0) {
      return defaultUrl;
    }

    const defaultKeyword = extractKeywordFromUrl(defaultUrl);
    if (defaultKeyword && !usedKeywords.has(defaultKeyword.toUpperCase().trim())) {
      return defaultUrl;
    }

    const remainingUrls = Object.entries(PORTAL_URLS)
      .filter(([kw]) => !usedKeywords.has(kw))
      .map(([, url]) => url);

    if (remainingUrls.length > 0) {
      return remainingUrls[Math.floor(Math.random() * remainingUrls.length)];
    }

    const remainingLowPriorityUrls = Object.entries(LOW_PRIORITY_PORTAL_URLS)
      .filter(([kw]) => !usedKeywords.has(kw))
      .map(([, url]) => url);

    if (remainingLowPriorityUrls.length > 0) {
      return remainingLowPriorityUrls[0];
    }

    return defaultUrl;
  } catch {
    return defaultUrl;
  }
}

async function portalRedirect(defaultUrl, code, delay = 0) {
  const chosenUrl = await resolveUrl(defaultUrl);
  const fullUrl = chosenUrl + code;

  const kwDefault = extractKeywordFromUrl(defaultUrl);
  const kwSelected = extractKeywordFromUrl(fullUrl);

  await Api.WriteLogRedirect(kwDefault, kwSelected);
 
  if (delay > 0) {
    setTimeout(() => { window.location.href = fullUrl; }, delay);
  } else {
    window.location.href = fullUrl;
  }
}

 function extractKeywordFromUrl(url) {
  if (!url) {
    return null;
  }

  const parts = url.split('/');
  const segment = parts[4] || null;
  if (!segment) return null;

  return segment.startsWith("REG") ? segment.slice(3) : segment;
}